var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 266,
    height: 230,
    viewBox: "0 0 266 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C87.78 0 175.56 0 266 0 C266 75.9 266 151.8 266 230 C178.22 230 90.44 230 0 230 C0 154.1 0 78.2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C73.2 30 86.4 30 100 30 C100 39.9 100 49.8 100 60 C109.9 60 119.8 60 130 60 C130 93 130 126 130 160 C64 160 -2 160 -70 160 C-70 127 -70 94 -70 60 C-60.1 60 -50.2 60 -40 60 C-40 50.1 -40 40.2 -40 30 C-26.8 30 -13.6 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(101,32)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C26.4 0 52.8 0 80 0 C80 9.9 80 19.8 80 30 C93.2 30 106.4 30 120 30 C120 39.9 120 49.8 120 60 C129.9 60 139.8 60 150 60 C150 99.6 150 139.2 150 180 C77.4 180 4.8 180 -70 180 C-70 140.4 -70 100.8 -70 60 C-60.1 60 -50.2 60 -40 60 C-40 50.1 -40 40.2 -40 30 C-26.8 30 -13.6 30 0 30 C0 20.1 0 10.2 0 0 Z M10 10 C10 19.9 10 29.8 10 40 C-3.2 40 -16.4 40 -30 40 C-30 49.9 -30 59.8 -30 70 C-39.9 70 -49.8 70 -60 70 C-60 103 -60 136 -60 170 C6 170 72 170 140 170 C140 137 140 104 140 70 C130.1 70 120.2 70 110 70 C110 60.1 110 50.2 110 40 C96.8 40 83.6 40 70 40 C70 30.1 70 20.2 70 10 C50.2 10 30.4 10 10 10 Z ",
    fill: "#626262",
    transform: "translate(91,22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchport);
export default __webpack_public_path__ + "static/media/switchport.2dcce0ba08fdf33f3ad3d9bfa83c4e3a.svg";
export { ForwardRef as ReactComponent };